import { ActionTree, MutationTree } from 'vuex'
import { AxiosResponse } from 'axios'
import { magnoliaServiceAPI } from '@/store/api-instance'
import { IRootState } from '@/store'
import {
  IHelpPagesState,
  IFetchHelpPagesRequest,
  IFetchHelpPagesResponse,
  HelpPagesMutationType,
  IHelpPagesMutations,
  HelpPagesActionType,
  IHelpPagesActions,
  IHelpPages
} from './interfaces'

const state = (): IHelpPagesState => ({
  helpPages: [],
  loading: false,
  alerts: []
})

const mutations: MutationTree<IHelpPagesState> & IHelpPagesMutations = {
  [HelpPagesMutationType.SET_LOADING] (state: IHelpPagesState, payload: boolean) {
    state.loading = payload
  },
  async [HelpPagesMutationType.SET_ALL_HELP_PAGES] (state: IHelpPagesState, payload: Array<IHelpPages>) {
    state.helpPages = payload
  },
  async [HelpPagesMutationType.SET_ALERTS] (state: IHelpPagesState, payload: Array<IHelpPages>) {
    state.alerts = payload
  }
}

const fetchHelpPages = async (dto: IFetchHelpPagesRequest): Promise<IFetchHelpPagesResponse> => {
  const response: AxiosResponse = await magnoliaServiceAPI.get<IFetchHelpPagesResponse>('helppages', { params: dto })
  return response.data
}
const fetchAlerts = async (
  dto?: { customertype?: string; uid?: string }
): Promise<IFetchHelpPagesResponse> => {
  const response: AxiosResponse =
    await magnoliaServiceAPI.get<IFetchHelpPagesResponse>(
      'alerts',
      {
        params: dto,
        headers: {
          'Cache-Control': 'no-store, no-cache, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0'
        }
      }
    )

  return response.data
}

const fetchPublicAlerts = async (
  dto?: { customertype?: string; uid?: string }
): Promise<IFetchHelpPagesResponse> => {
  const response: AxiosResponse =
    await magnoliaServiceAPI.get<IFetchHelpPagesResponse>(
      'publicalerts',
      {
        params: dto,
        headers: {
          'Cache-Control': 'no-store, no-cache, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0'
        }
      }
    )

  return response.data
}

const fetchAllHelpPages = async (
  dto: IFetchHelpPagesRequest,
  oldData?: Array<IHelpPages>
): Promise<Array<IHelpPages>> => {
  const { results, total, limit } = await fetchHelpPages(dto)

  oldData = (oldData || []).concat(results)

  if (total > oldData.length) {
    return await fetchAllHelpPages({ ...dto, offset: oldData.length, limit }, oldData)
  }

  return oldData
}

const actions: ActionTree<IHelpPagesState, IRootState> & IHelpPagesActions = {
  async [HelpPagesActionType.FETCH_ALL_HELP_PAGES] ({ commit }, dto: IFetchHelpPagesRequest) {
    commit(HelpPagesMutationType.SET_LOADING, true)
    const data = await fetchAllHelpPages(dto)
    commit(HelpPagesMutationType.SET_ALL_HELP_PAGES, data)
    commit(HelpPagesMutationType.SET_LOADING, false)
  },
  async [HelpPagesActionType.FETCH_ALERTS] (
    { commit },
    dto: {
    public: boolean
    customertype?: string
    uid?: string
  }
  ) {
    commit(HelpPagesMutationType.SET_LOADING, true)

    const apiToUse = dto.public
      ? fetchPublicAlerts(dto)
      : fetchAlerts(dto)

    const alerts = await apiToUse

    commit(HelpPagesMutationType.SET_ALERTS, alerts.results)
    commit(HelpPagesMutationType.SET_LOADING, false)
  }
}

export default {
  state,
  mutations,
  actions
}
